import { render } from "./Overviews.vue?vue&type=template&id=3f9f2ca3&scoped=true&ts=true"
import script from "./Overviews.vue?vue&type=script&lang=ts"
export * from "./Overviews.vue?vue&type=script&lang=ts"

import "./Overviews.vue?vue&type=style&index=0&id=3f9f2ca3&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9f2ca3"]])

export default __exports__